import { Pipe, PipeTransform } from '@angular/core';
import { NotificationBallSeverity } from '../../core/components/layout/topbar/shared/notification-severity-ball/notification-severity-ball.component';
import { AutomatedTransferNotificationType } from '../../pages/transfers/enum/automated-transfer-notification-type.enum';

@Pipe({
  name: 'automatedTransferNotificationTypeToBallSeverity',
  standalone: true,
})
export class AutomatedTransferNotificationTypeToBallSeverityPipe implements PipeTransform {
  transform(notificationType?: AutomatedTransferNotificationType): NotificationBallSeverity {
    switch (notificationType) {
      case AutomatedTransferNotificationType.AUTOMATED_TRANSFER_COMPLETED:
        return 'success';
      case AutomatedTransferNotificationType.AUTOMATED_TRANSFER_GEOFENCE_ENTERED:
      case AutomatedTransferNotificationType.AUTOMATED_TRANSFER_GEOFENCE_LEFT:
      case AutomatedTransferNotificationType.AUTOMATED_TRANSFER_ITEM_PAUSED:
      case AutomatedTransferNotificationType.AUTOMATED_TRANSFER_GEOFENCE_CHANGES:
        return 'warning';
      case AutomatedTransferNotificationType.AUTOMATED_TRANSFER_EQUIPMENT_BLOCKED:
      case AutomatedTransferNotificationType.AUTOMATED_TRANSFER_CANCELLED:
      case AutomatedTransferNotificationType.AUTOMATED_TRANSFER_DELIVERY_TIME_EXCEEDED:
        return 'danger';
      default:
        return 'info';
    }
  }
}
